import type { FC } from 'react';
import { useGameStartStore, useIsStartingGame, useIsWaitingForDefenseCode } from 'features/games';
import { JackpotStatisticsHost } from 'features/jackpots';

/**
 * Layout-level glue for the statistics drawer's game-launch wiring.
 *
 * The jackpots feature cannot import the games feature itself: games already consumes jackpot
 * data (`useEffectiveGameData`), so a jackpots → games import closes an import cycle
 * (`import/no-cycle`). A layout may depend on both features, so the launch action and the
 * launch-in-flight guard are subscribed to here and handed down as props.
 *
 * Deliberately a LEAF component rather than hooks inside `Lobby`: the launch flags flip on every
 * game start, and `Lobby` is memoised specifically to never rerender after mount.
 */
const LobbyJackpotStatistics: FC = () => {
  const startGame = useGameStartStore((state) => state.startGame);
  const isStartingGame = useIsStartingGame();
  const isWaitingForDefenseCode = useIsWaitingForDefenseCode();

  return (
    <JackpotStatisticsHost isLaunchBlocked={isStartingGame || isWaitingForDefenseCode} onStartGame={startGame} />
  );
};

export default LobbyJackpotStatistics;
